import type { ReactNode } from 'react';

interface SectionProps {
  title: string;
  description?: string;
  children: ReactNode;
}

export function Section({ title, description, children }: SectionProps) {
  return (
    <section className="feluda-section">
      <header className="feluda-section-header">
        <h2 className="feluda-section-title">{title}</h2>
        {description && <p className="feluda-section-description">{description}</p>}
      </header>
      <div className="feluda-section-body">{children}</div>
    </section>
  );
}

interface RowProps {
  label: string;
  description?: string;
  control: ReactNode;
}

export function Row({ label, description, control }: RowProps) {
  return (
    <div className="feluda-row">
      <div className="feluda-row-label">
        <span className="feluda-row-label-text">{label}</span>
        {description && <span className="feluda-row-label-description">{description}</span>}
      </div>
      <div className="feluda-row-control">{control}</div>
    </div>
  );
}